import MenuNames from "../../../constants/Menu/MenuNames.json";
import UserPropertyView from "../../../views/UserProperty";

const UserProperty = [
  {
    menuName: MenuNames.USER_PROPERTY,
    path: "/user-properties",
    component: UserPropertyView,
    exact: true,
  },
];

export default UserProperty;
